<app-breadcrumb [title]="'Registro de siniestro vial'" [items]="['Seguridad Vial']"
  [active_item]="'Nuevo siniestro'"></app-breadcrumb>

<div class="container-fluid">

  <!-- Card 1: Información general -->
  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <strong>1. INFORME GENERAL</strong>
    </div>
    <div class="card-body">
      <form [formGroup]="formSiniestro">
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label text-dark">
              Consecutivo: <a class="text-danger"> *</a>
            </label>
            <input type="text" class="form-control" formControlName="consecutivo" readonly />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Fecha del siniestro: <a class="text-danger"> *</a></label>
            <input type="date" class="form-control" placeholder="Ingrese la fecha" formControlName="fecha_siniestro"
              [attr.max]="hoy" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Hora del siniestro: <a class="text-danger"> *</a></label>
            <input type="time" class="form-control" placeholder="Ingrese la hora" formControlName="hora_siniestro" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Fecha del reporte: <a class="text-danger"> *</a></label>
            <input type="date" class="form-control" placeholder="Ingrese la fecha" formControlName="fecha_reporte"
              [attr.max]="hoy" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Hora del reporte: <a class="text-danger"> *</a></label>
            <input type="time" class="form-control" placeholder="Ingrese la hora" formControlName="hora_reporte" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Tipo de siniestro: <a class="text-danger"> *</a></label>
            <ng-select [items]="tiposSiniestro" placeholder="Seleccione el tipo de siniestro" bindLabel="nombre"
              bindValue="id" formControlName="tipo_siniestro"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Nivel de severidad: <a class="text-danger"> *</a></label>
            <ng-select [items]="nivelesSeveridad" placeholder="Seleccione el nivel de severidad" bindLabel="nombre"
              bindValue="id" formControlName="nivel_severidad"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Lesionados: <a class="text-danger"> *</a></label>
            <input type="number" class="form-control" placeholder="Ingrese el número de lesionados"
              formControlName="lesionados" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Fatalidad: <a class="text-danger"> *</a></label>
            <input type="number" class="form-control" placeholder="Ingrese el número de fatalidades"
              formControlName="fatalidad" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Número de víctimas: <a class="text-danger"> *</a></label>
            <input type="number" class="form-control" placeholder="Ingrese el número de víctimas"
              formControlName="numero_victimas" />
          </div>
          <div class="col-md-12">
            <label class="form-label text-dark">Descripción: <a class="text-danger"> *</a></label>
            <textarea class="form-control" rows="3" placeholder="Ingrese la descripción del siniestro"
              formControlName="descripcion_ocurrido"></textarea>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Card 2: Lugar -->
  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <strong>2. LUGAR DEL SINIESTRO</strong>
    </div>
    <div class="card-body">
      <form [formGroup]="formSiniestro">
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label text-dark">Municipio: <a class="text-danger"> *</a></label>
            <ng-select [items]="municipios" placeholder="Seleccione el municipio" bindLabel="MUNICIPIO"
              bindValue="IDMUN" formControlName="municipio" (change)="onMunicipioChange($event)">
              <ng-template ng-label-tmp let-item="item">
                {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Departamento: <a class="text-danger"> *</a></label>
            <ng-select [items]="departamentos" placeholder="Seleccione el departamento" bindLabel="nombre"
              bindValue="id" formControlName="departamento"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Dirección / Referencia: <a class="text-danger"> *</a></label>
            <input type="text" class="form-control" placeholder="Ingrese la dirección de referencia"
              formControlName="direccion_referencia" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Latitud:</label>
            <input type="text" class="form-control" placeholder="Ingrese la latitud"
              formControlName="coordenadas_latitud" (input)="updateMap()" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Longitud:</label>
            <input type="text" class="form-control" placeholder="Ingrese la longitud"
              formControlName="coordenadas_longitud" (input)="updateMap()" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Ruta / Trayecto:</label>
            <input type="text" class="form-control" placeholder="Ingrese la ruta o trayecto"
              formControlName="ruta_trayecto" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Vía:</label>
            <ng-select [items]="vias" placeholder="Seleccione la vía" bindLabel="nombre" bindValue="id"
              formControlName="via"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Condiciones climáticas:</label>
            <ng-select [items]="condicionesClimaticas" placeholder="Seleccione las condiciones climáticas"
              bindLabel="nombre" bindValue="id" formControlName="condiciones_climaticas"></ng-select>
          </div>
          <div class="col-md-12 mt-3" *ngIf="mapUrl">
            <iframe width="100%" height="300" frameborder="0" [src]="mapUrl | safeUrl">
            </iframe>
          </div>

        </div>
      </form>
    </div>
  </div>

  <!-- Card 3: Vehículo -->
  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <strong>3. INFORMACIÓN DEL VEHÍCULO</strong>
    </div>
    <div class="card-body">
      <form [formGroup]="formSiniestro">
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label text-dark">Placa: <a class="text-danger"> *</a></label>
            <div class="input-group">
              <input type="text" class="form-control text-uppercase" placeholder="Ingrese la placa"
                formControlName="placa" maxlength="7" />
              <button type="button" class="btn btn-primary" (click)="buscarVehiculoPorPlaca()">
                <i class="icofont icofont-search"></i>
              </button>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Tipo de vehículo: <a class="text-danger"> *</a></label>
            <ng-select [items]="tiposVehiculo" bindLabel="tipos" placeholder="Seleccione el tipo de vehículo"
              bindValue="idTipos" formControlName="tipo_vehiculo"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Marca: <a class="text-danger"> *</a></label>
            <ng-select [items]="marcasVehiculo" bindLabel="marca" bindValue="id" placeholder="Seleccione la marca"
              formControlName="marca"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Línea: <a class="text-danger"> *</a></label>
            <input type="text" class="form-control" placeholder="Ingrese la línea" formControlName="linea" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Modelo: <a class="text-danger"> *</a></label>
            <ng-select [items]="modelosVehiculo" bindLabel="modelo" bindValue="id" placeholder="Seleccione el modelo"
              formControlName="modelo"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Relación: <a class="text-danger"> *</a></label>
            <ng-select [items]="propiedadesVehiculo" bindLabel="relacion" bindValue="id"
              placeholder="Seleccione la relación" formControlName="propiedad_vehiculo"></ng-select>
          </div>

        </div>
      </form>
    </div>
  </div>

  <div class="card mb-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <strong>4. CONDUCTORES INVOLUCRADOS</strong>

    </div>
    <div class="card-body">
      <div class="table-responsive" *ngIf="conductoresInvolucrados.length > 0; else sinConductores">
        <table class="table table-hover table-bordered mb-0" id="tblConductoresSiniestro">
          <thead class="bg-primary text-white">
            <tr>
              <th class="text-center">NOMBRE</th>
              <th class="text-center">NÚMERO DE DOCUMENTO</th>
              <th class="text-center">ROL</th>
              <th class="text-center">ESTADO</th>
              <th class="text-center">CATEGORIA</th>
              <th class="text-center">LICENCIA</th>
              <th class="text-center">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let conductor of conductoresInvolucrados | slice: (pageConductores - 1) * pageSizeConductores : pageConductores * pageSizeConductores; let i = index">
              <td class="text-center text-uppercase">
                {{ conductor.propietarioData?.primernombre }} {{ conductor.propietarioData?.segundonombre }}
                {{conductor.propietarioData?.papellidos}}
                {{conductor.propietarioData?.seapellidos}}
              </td>
              <td class="text-center">{{ conductor.n_documento }}</td>
              <td class="text-center">{{ conductor.tipoActorVialData?.descripcion }}</td>
              <td class="text-center">{{ conductor.estadoMomentoSiniestroData?.descripcion }}</td>
              <td class="text-center">{{ conductor.categoria }}</td>
              <td class="text-center">{{ conductor.n_licencia }}</td>
              <td class="text-center">
                <div class="action text-center">
                  <ul class="list-inline d-flex justify-content-center gap-3 mb-0">
                    <li class="list-inline-item edit">
                      <a href="javascript:void(0)">
                        <i class="icon-pencil-alt"
                          (click)="abrirModalConductor(conductorModal, conductor, ((pageConductores - 1) * pageSizeConductores) + i)"
                          ngbTooltip="Editar"></i>
                      </a>
                    </li>
                    <li class="list-inline-item delete">
                      <a href="javascript:void(0)">
                        <i class="icon-trash"
                          (click)="eliminarConductor(((pageConductores - 1) * pageSizeConductores) + i)"
                          ngbTooltip="Inactivar"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row align-items-center mt-4 g-2" *ngIf="conductoresInvolucrados.length > 0">
        <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
          <label for="pageSizeConductores" class="me-2 mb-0">Mostrar:</label>
          <select id="pageSizeConductores" class="form-select w-auto" [(ngModel)]="pageSizeConductores"
            (change)="pageConductores = 1">
            <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <div class="col-12 col-md-4 text-center my-2 my-md-0">
          <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ conductoresInvolucrados.length || 0
              }}</b></span>
        </div>

        <div class="col-12 col-md-4 text-center text-md-end">
          <pagination-controls (pageChange)="pageConductores = $event" [maxSize]="5" [directionLinks]="true"
            [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
        </div>
      </div>
      <ng-template #sinConductores>
        <div class="text-center text-primary">No hay conductores agregados aún.</div>
      </ng-template>
    </div>
    <div class="btn-showcase text-center mb-3">
      <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
        (click)="exportarExcel('tblConductoresSiniestro', 'Listado_Conductores_Siniestro')">
        <i class="icofont icofont-file-excel"></i> EXCEL
      </button>

      <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
        (click)="exportToPDF('tblConductoresSiniestro', 'Listado_Conductores_Siniestro', 'Listado de Conductores Involucrados')">
        <i class="icofont icofont-file-pdf"></i> PDF
      </button>

      <button class="btn btn-primary" type="button" placement="top" ngbTooltip="Crear Conductor Involucrado"
        (click)="abrirModalConductor(conductorModal)">
        <i class="icofont icofont-plus"></i> Agregar
      </button>
    </div>
  </div>

  <div class="card mb-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <strong>5. VEHÍCULOS INVOLUCRADOS</strong>
    </div>
    <div class="card-body">
      <div class="table-responsive" *ngIf="vehiculosInvolucrados.length > 0; else sinVehiculos">
        <table class="table table-hover table-bordered mb-0" id="tblVehiculosSiniestro">
          <thead class="bg-primary text-white">
            <tr>
              <th class="text-center">PLACA</th>
              <th class="text-center">TIPO</th>
              <th class="text-center">PROPIEDAD</th>
              <th class="text-center">SOAT</th>
              <th class="text-center">TECNOMECÁNICA</th>
              <th class="text-center">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let vehiculo of vehiculosInvolucrados | slice: (pageVehiculos - 1) * pageSizeVehiculos : pageVehiculos * pageSizeVehiculos; let i = index">
              <td class="text-center">{{ vehiculo.placa }}</td>
              <td class="text-center">{{ getNombreTipoVehiculo(vehiculo.tipo_vehiculo) }}</td>
              <td class="text-center">{{ getNombrePropiedadVehiculo(vehiculo.propiedad_vehiculo) }}</td>
              <td class="text-center">
                {{ vehiculo.fecha_vencimiento ? (vehiculo.fecha_vencimiento | date:'dd/MM/yyyy') : 'dd/mm/yyyy' }}
              </td>
              <td class="text-center">
                {{ vehiculo.revision_tecnomecanica ? (vehiculo.revision_tecnomecanica | date:'dd/MM/yyyy') :
                'dd/mm/yyyy' }}
              </td>
              <td class="text-center">
                <div class="action text-center">
                  <ul class="list-inline d-flex justify-content-center gap-3 mb-0">
                    <li class="list-inline-item edit">
                      <a href="javascript:void(0)">
                        <i class="icon-pencil-alt"
                          (click)="abrirModalVehiculo(vehiculoModal, vehiculo, ((pageVehiculos - 1) * pageSizeVehiculos) + i)"
                          ngbTooltip="Editar"></i>
                      </a>
                    </li>
                    <li class="list-inline-item delete">
                      <a href="javascript:void(0)">
                        <i class="icon-trash" (click)="eliminarVehiculo(((pageVehiculos - 1) * pageSizeVehiculos) + i)"
                          ngbTooltip="Inactivar"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row align-items-center mt-4 g-2" *ngIf="vehiculosInvolucrados.length > 0">
        <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
          <label for="pageSizeVehiculos" class="me-2 mb-0">Mostrar:</label>
          <select id="pageSizeVehiculos" class="form-select w-auto" [(ngModel)]="pageSizeVehiculos"
            (change)="pageVehiculos = 1">
            <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <div class="col-12 col-md-4 text-center my-2 my-md-0">
          <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ vehiculosInvolucrados.length || 0
              }}</b></span>
        </div>

        <div class="col-12 col-md-4 text-center text-md-end">
          <pagination-controls (pageChange)="pageVehiculos = $event" [maxSize]="5" [directionLinks]="true"
            [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
        </div>
      </div>
      <ng-template #sinVehiculos>
        <div class="text-center text-primary">No hay vehículos agregados aún.</div>
      </ng-template>
    </div>
    <div class="btn-showcase text-center mb-3">
      <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
        (click)="exportarExcel('tblVehiculosSiniestro', 'Listado_Vehiculos_Siniestro')">
        <i class="icofont icofont-file-excel"></i> EXCEL
      </button>

      <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
        (click)="exportToPDF('tblVehiculosSiniestro', 'Listado_Vehiculos_Siniestro', 'Listado de Vehículos Involucrados')">
        <i class="icofont icofont-file-pdf"></i> PDF
      </button>

      <button class="btn btn-primary" type="button" placement="top" ngbTooltip="Crear Vehículo"
        (click)="abrirModalVehiculo(vehiculoModal)">
        <i class="icofont icofont-plus"></i> Agregar
      </button>
    </div>
  </div>

  <div class="card mb-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <strong>6. OTROS INVOLUCRADOS</strong>
    </div>
    <div class="card-body">
      <div class="table-responsive" *ngIf="otrosInvolucrados.length > 0; else sinOtros">
        <table class="table table-hover table-bordered mb-0" id="tblOtrosSiniestro">
          <thead class="bg-primary text-white">
            <tr>
              <th class="text-center">Tipo actor</th>
              <th class="text-center">Nombre</th>
              <th class="text-center">Documento</th>
              <th class="text-center">Placa</th>
              <th class="text-center">Lesiones</th>
              <th class="text-center">Daños</th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let otro of otrosInvolucrados | slice: (pageOtros - 1) * pageSizeOtros : pageOtros * pageSizeOtros; let i = index">
              <td class="text-center">{{ otro.tipoActorVialData?.descripcion }}</td>
              <td class="text-center">{{ otro.nombre }}</td>
              <td class="text-center">{{ otro.n_documento }}</td>
              <td class="text-center">{{ otro.placa }}</td>
              <td class="text-center">{{ otro.lesiones == 1 ? 'Sí' : 'No' }}</td>
              <td class="text-center">{{ otro.danos == 1 ? 'Sí' : 'No' }}</td>
              <td class="text-center">
                <div class="action text-center">
                  <ul class="list-inline d-flex justify-content-center gap-3 mb-0">
                    <li class="list-inline-item edit">
                      <a href="javascript:void(0)">
                        <i class="icon-pencil-alt"
                          (click)="abrirModalOtro(otroModal, otro, ((pageOtros - 1) * pageSizeOtros) + i)"
                          ngbTooltip="Editar"></i>
                      </a>
                    </li>
                    <li class="list-inline-item delete">
                      <a href="javascript:void(0)">
                        <i class="icon-trash" (click)="eliminarOtroInvolucrado(((pageOtros - 1) * pageSizeOtros) + i)"
                          ngbTooltip="Inactivar"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row align-items-center mt-4 g-2" *ngIf="otrosInvolucrados.length > 0">
        <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
          <label for="pageSizeOtros" class="me-2 mb-0">Mostrar:</label>
          <select id="pageSizeOtros" class="form-select w-auto" [(ngModel)]="pageSizeOtros" (change)="pageOtros = 1">
            <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <div class="col-12 col-md-4 text-center my-2 my-md-0">
          <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ otrosInvolucrados.length || 0
              }}</b></span>
        </div>

        <div class="col-12 col-md-4 text-center text-md-end">
          <pagination-controls (pageChange)="pageOtros = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
            previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
        </div>
      </div>
      <ng-template #sinOtros>
        <div class="text-center text-primary">No hay otros involucrados agregados aún.</div>
      </ng-template>
    </div>
    <div class="btn-showcase text-center mb-3">
      <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
        (click)="exportarExcel('tblOtrosSiniestro', 'Listado_Otros_Siniestro')">
        <i class="icofont icofont-file-excel"></i> EXCEL
      </button>

      <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
        (click)="exportToPDF('tblOtrosSiniestro', 'Listado_Otros_Siniestro', 'Listado de Otros Involucrados')">
        <i class="icofont icofont-file-pdf"></i> PDF
      </button>

      <button class="btn btn-primary" type="button" placement="top" ngbTooltip="Crear otro involucrado"
        (click)="abrirModalOtro(otroModal)">
        <i class="icofont icofont-plus"></i> Agregar
      </button>
    </div>
  </div>

  <div class="card mb-3 shadow-sm">
    <div class="card-header bg-primary text-white">
      <strong>7. SOPORTE DIGITAL</strong>
    </div>

    <div class="card-body">
      <div class="upload-card">
        <div class="row">
          <!-- Documentos ya guardados -->
          <div class="col-md-3 col-sm-4 col-6 mb-3" *ngFor="let doc of documentosGuardados; let i = index">

            <div class="border rounded p-2 text-center h-100">
              <img *ngIf="doc.contentType?.startsWith('image')" [src]="doc.url" class="preview-image img-fluid mb-2">
              <div *ngIf="doc.contentType?.includes('pdf')" class="pdf-preview mb-2">
                <i class="icofont icofont-file-pdf" style="font-size:50px;color:#dc3545;"></i>
              </div>
              <div class="small text-truncate mb-2">
                <strong>{{ doc.name }}</strong>
              </div>
              <a [href]="doc.url" target="_blank" class="btn btn-outline-primary btn-sm">
                <i class="icofont icofont-eye"></i> Ver
              </a>
              <button type="button" class="btn btn-outline-danger btn-sm" (click)="eliminarDocumentoGuardado(doc)">
                <i class="icofont icofont-trash"></i>
              </button>
            </div>
          </div>

          <!-- Documentos nuevos -->
          <div class="col-md-3 col-sm-4 col-6 mb-3" *ngFor="let archivo of archivosSeleccionados; let i = index">

            <div class="border rounded p-2 text-center h-100">
              <img *ngIf="previews[i]" [src]="previews[i]" class="preview-image img-fluid mb-2">
              <div *ngIf="!previews[i]" class="pdf-preview mb-2">
                <i class="icofont icofont-file-pdf" style="font-size:50px;color:#dc3545;"></i>
              </div>
              <div class="small text-truncate mb-2">
                <strong>Documento {{ i + 1 }}: {{ archivo.name }}</strong>
              </div>
              <button type="button" class="btn btn-outline-danger btn-sm" (click)="eliminarDocumento(i)">
                <i class="icofont icofont-trash"></i>
              </button>
            </div>
          </div>
        </div>


        <!-- Botón para agregar otro archivo -->
        <div class="text-center mt-3">
          <input type="file" id="archivoSiniestro" class="d-none" accept="image/*,.pdf"
            (change)="onFileSelected($event)">
          <label for="archivoSiniestro" class="btn btn-outline-primary">
            <i class="icofont icofont-plus"></i> Agregar documento
          </label>
        </div>
      </div>
    </div>

  </div>

  <!-- Botones -->
  <div class="text-center my-4">
    <button class="btn btn-primary" type="button" (click)="guardar()">
      <i class="icofont icofont-save"></i> Guardar
    </button>
  </div>
</div>

<ng-template #conductorModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title text-dark">{{ conductorEditandoIndex !== null ? 'Editar conductor' : 'Agregar conductor' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formConductorInvolucrado" class="row g-3">
      <div class="col-md-4">
        <label class="form-label text-dark">Placa del vehículo</label>
        <div class="input-group">
          <input type="text" class="form-control text-uppercase" [value]="formSiniestro.get('placa')?.value || ''"
            readonly />
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="buscarConductoresPorPlaca()">
            <i class="icofont icofont-search"></i> Buscar persona
          </button>
        </div>
      </div>
      <div class="col-md-4" *ngIf="conductoresPorPlaca.length > 0">
        <label class="form-label text-dark">Persona encontrada</label>
        <ng-select [items]="conductoresPorPlaca" bindValue="conductor_id" placeholder="Seleccione una persona"
          (change)="onConductorSeleccionadoEnModal($event)">
          <ng-template ng-label-tmp let-item="item">
            {{ item.propietario?.primernombre }} {{ item.propietario?.segundonombre }} {{ item.propietario?.papellidos
            }} {{ item.propietario?.seapellidos }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.propietario?.primernombre }} {{ item.propietario?.segundonombre }} {{ item.propietario?.papellidos
            }} {{ item.propietario?.seapellidos }}
          </ng-template>
        </ng-select>

      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Tipo de documento</label>
        <ng-select [items]="tiposDocumento" bindLabel="label" bindValue="value"
          formControlName="tipodocumento"></ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">N° Documento</label>
        <input type="number" class="form-control" formControlName="n_documento" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Rol en el siniestro</label>
        <ng-select [items]="rolesSiniestro" bindLabel="label" bindValue="value"
          formControlName="rol_siniestro"></ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Fecha de nacimiento</label>
        <input type="date" class="form-control" formControlName="fecha_nacimiento" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Estado en el momento</label>
        <ng-select [items]="estadosConductor" bindLabel="descripcion" bindValue="id"
          formControlName="estado_momento_siniestro"></ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Categoría</label>
        <ng-select [items]="categoriasLicencia" bindLabel="label" bindValue="value"
          formControlName="categoria"></ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">N° Licencia</label>
        <input type="number" class="form-control" formControlName="n_licencia" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Fecha expedición</label>
        <input type="date" class="form-control" formControlName="fecha_expedicion" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Fecha vencimiento</label>
        <input type="date" class="form-control" formControlName="fecha_vencimiento" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Usaba cinturón</label>
        <ng-select [items]="opcionesSiNo" bindLabel="descripcion" bindValue="id"
          formControlName="usaba_cinturon"></ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Misión laboral</label>
        <ng-select [items]="opcionesSiNo" bindLabel="descripcion" bindValue="id"
          formControlName="mision_laboral"></ng-select>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" type="button" (click)="modal.dismiss()">Cancelar</button>
    <button class="btn btn-primary" type="button" (click)="guardarConductorDesdeModal(modal)">{{ conductorEditandoIndex
      !== null ? 'Actualizar' : 'Guardar' }}</button>
  </div>
</ng-template>

<ng-template #vehiculoModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title text-dark">{{ vehiculoEditandoIndex !== null ? 'Editar vehículo involucrado' : 'Agregar vehículo
      involucrado' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formVehiculoInvolucrado" class="row g-3">
      <div class="col-md-4">
        <label class="form-label text-dark">Placa</label>
        <div class="input-group">
          <input type="text" class="form-control" formControlName="placa_involucrado" maxlength="7" />
        </div>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Número interno</label>
        <input type="text" class="form-control" formControlName="numero_interno" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Tipo de vehículo</label>
        <ng-select [items]="tiposVehiculo" bindLabel="tipos" bindValue="idTipos"
          formControlName="tipo_vehiculo"></ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Propiedad del vehículo</label>
        <ng-select [items]="propiedadesVehiculo" bindLabel="relacion" bindValue="id"
          formControlName="propiedad_vehiculo"></ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Fecha vencimiento SOAT</label>
        <input type="date" class="form-control" formControlName="fecha_vencimiento" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Revisión tecnomecánica</label>
        <input type="date" class="form-control" formControlName="revision_tecnomecanica" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Carga</label>
        <input type="number" class="form-control" formControlName="carga" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Descripción carga</label>
        <input type="text" class="form-control" formControlName="descripcion_carga" />
      </div>
      <div class="col-md-12">
        <label class="form-label text-dark">Empresa transportadora</label>
        <input type="text" class="form-control" formControlName="empresa_transportadora" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" type="button" (click)="modal.dismiss()">Cancelar</button>
    <button class="btn btn-primary" type="button" (click)="guardarVehiculoDesdeModal(modal)">{{ vehiculoEditandoIndex
      !== null ? 'Actualizar' : 'Guardar' }}</button>
  </div>
</ng-template>

<ng-template #otroModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ otroEditandoIndex !== null ? 'Editar otro involucrado' : 'Agregar otro involucrado' }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formOtrosInvolucrado" class="row g-3">
      <div class="col-md-4">
        <label class="form-label text-dark">Tipo de actor vial: <a class="text-danger">*</a></label>
        <ng-select [items]="tiposActorVial" bindLabel="descripcion" bindValue="id" formControlName="tipo_actor_vial"
          placeholder="Seleccione tipo de actor vial">
        </ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Nombre</label>
        <input type="text" class="form-control" formControlName="nombre" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Documento</label>
        <input type="number" class="form-control" formControlName="n_documento" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Placa</label>
        <input type="text" class="form-control" formControlName="placa" maxlength="7" />
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Lesiones</label>
        <ng-select [items]="opcionesSiNo" bindLabel="descripcion" bindValue="id" formControlName="lesiones"></ng-select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-dark">Daños</label>
        <ng-select [items]="opcionesSiNo" bindLabel="descripcion" bindValue="id" formControlName="danos"></ng-select>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" type="button" (click)="modal.dismiss()">Cancelar</button>
    <button class="btn btn-primary" type="button" (click)="guardarOtroDesdeModal(modal)">{{ otroEditandoIndex !== null ?
      'Actualizar' : 'Guardar' }}</button>
  </div>
</ng-template>